import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageHeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '6px',
});

export const TitleSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

export const BackButton = styled(IconButton)({
  color: 'var(--instructions)',
  width: '36px',
  height: '36px',
  borderRadius: '13px',
  border: '2px solid var(--box-shadow)',
  '&:hover': {
    backgroundColor: 'var(--primary-blue)',
    filter: 'brightness(0.9)',
  },
});

export const BackIcon = styled(Box)({
  fontSize: '20px',
});

export const PageTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '28px',
  fontWeight: 600,
  color: 'var(--primary-blue)',
});

export const GRNPageTitle = styled(Typography)`
  font-family: 'Outfit';
  font-weight: 500;
  font-size: 24px;
  color: #75838a;
`;

export const ButtonIcon = styled(Box)({
  fontSize: '20px',
});
